import { render, staticRenderFns } from "./inspectionDate.vue?vue&type=template&id=15b106a0"
import script from "./inspectionDate.vue?vue&type=script&lang=js"
export * from "./inspectionDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports